import * as Types from '../definitions';
import * as Enums from '../enums';

const programId = 'program-1';

export const emptyQuestion: Types.Question = {
    programId,
    id: '0',
    title: 'Question 0',
    description: '',
    helpText: '',
    internalDescription: 'generic internal description',
    reportingGroup: null,
    type: Enums.QuestionType.None,
    createDate: '2018-01-31T21:23:47.298Z',
};

export const textQuestion: Types.TextQuestion = {
    programId,
    id: '1',
    title: 'Text Question 1',
    description: 'Mock Text Question',
    helpText: '',
    internalDescription: 'text internal description',
    reportingGroup: null,
    type: Enums.QuestionType.Text,
    createDate: '2018-01-31T21:23:47.298Z',
    validationRegex: 'The regex',
    formattingErrorMessage: 'The validation message',
};

export const dateTimeQuestion: Types.DateTimeQuestion = {
    programId,
    id: '2',
    title: 'DateTime Question 1',
    description: 'Mock DateTime Question',
    helpText: '',
    internalDescription: 'dateTime internal description',
    reportingGroup: null,
    type: Enums.QuestionType.DateTime,
    createDate: '2018-01-31T21:23:47.298Z',
};

export const dropdownQuestion: Types.DropdownQuestion = {
    programId,
    id: '3',
    title: 'Dropdown Question 1',
    description: 'Mock Dropdown Question',
    helpText: '',
    internalDescription: 'dropdown internal description',
    reportingGroup: null,
    type: Enums.QuestionType.Dropdown,
    createDate: '2018-01-31T21:23:47.298Z',
};

export const fileUploadQuestion: Types.FileUploadQuestion = {
    programId,
    id: '4',
    title: 'FileUpload Question 1',
    description: 'Mock FileUpload Question',
    helpText: '',
    internalDescription: 'file upload internal description',
    reportingGroup: null,
    type: Enums.QuestionType.FileUpload,
    createDate: '2018-01-31T21:23:47.298Z',
    maxFileSizeMb: 5,
};

export const numberQuestion: Types.NumberQuestion = {
    programId,
    id: '5',
    title: 'Number Question 1',
    description: 'Mock Number Question',
    helpText: '',
    internalDescription: 'number internal description',
    reportingGroup: null,
    type: Enums.QuestionType.Number,
    createDate: '2018-01-31T21:23:47.298Z',
};

export const cascadingDropdownQuestion: Types.CascadingDropdownQuestion = {
    programId,
    id: '6',
    title: 'Cascading Dropdown Question 1',
    description: 'Mock Cascading Dropdown Question',
    helpText: '',
    internalDescription: 'cascading internal description',
    reportingGroup: 'Reporting Group 1',
    type: Enums.QuestionType.CascadingDropdown,
    createDate: '2018-01-31T21:23:47.298Z',
    dataSetId: 'data-set-1',
    layers: [
        { dataSetPropertyId: 1, label: 'Layer 1', displayAsCurrency: false, isRewardAmount: false },
        { dataSetPropertyId: 2, label: 'Layer 2', displayAsCurrency: false, isRewardAmount: false },
    ],
};

export const multiSelectQuestion: Types.MultiSelectQuestion = {
    programId,
    id: '7',
    title: 'MultiSelect Question 1',
    description: 'Mock MultiSelect Question',
    helpText: '',
    internalDescription: 'multiselect internal description',
    reportingGroup: 'Reporting Group 1',
    type: Enums.QuestionType.MultiSelect,
    createDate: '2018-01-31T21:23:47.298Z',
};

export const referredIndividualNameQuestion: Types.ReferredIndividualName = {
    programId,
    id: '8',
    title: 'Referred Individual Name Question 1',
    description: 'Mock Referred Individual Name  Question',
    helpText: '',
    internalDescription: 'referred name internal description',
    reportingGroup: null,
    type: Enums.QuestionType.ReferredIndividualName,
    createDate: '2018-01-31T21:23:47.298Z',
    validationRegex: 'The regex',
    formattingErrorMessage: 'The validation message',
};

export const referredIndividualEmailQuestion: Types.ReferredIndividualEmail = {
    programId,
    id: '9',
    title: 'Referred Individual Email Question 1',
    description: 'Mock Referred Individual Email Question',
    helpText: '',
    internalDescription: 'referred email internal description',
    reportingGroup: null,
    type: Enums.QuestionType.ReferredIndividualEmail,
    createDate: '2018-01-31T21:23:47.298Z',
    validationRegex: 'The regex',
    formattingErrorMessage: 'The validation message',
};
